import { render, staticRenderFns } from "./YandexMetrika.vue?vue&type=template&id=89825256"
import script from "./YandexMetrika.vue?vue&type=script&lang=js"
export * from "./YandexMetrika.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports